import { PageViewEventLogger } from '@repo/tracking-service';
import { MainTitle } from '@repo/ui';
import cn from 'clsx';
import { ReactElement } from 'react';

import { EmptyRefundHistory, MyRefundHistoryTopNavigation as TopNavigation, OngoingRefundButton, RefundHistoryCard } from '@/components/my';
import layoutStyle from '@/components/my/common/layout.module.scss';
import { useRefundItemContext } from '@/components/my/refund-history/providers/RefundItemContext';
import { RefundItemFetchGuard } from '@/components/my/refund-history/providers/RefundItemFetchGuard';

export default function MyRefundHistoryPage() {
  const { refundItems, userName } = useRefundItemContext();

  return (
    <main className="bg-gray-50">
      <TopNavigation />

      <div className={cn(layoutStyle.main_content, 'h-px min-h-screen')}>
        {refundItems.length ? (
          <section className="bg-gray-50 pb-normal-xlarge">
            <MainTitle title="환급받은 내역" size="medium" description={`비즈넵 환급에서 결제를 완료한\n${userName}님의 환급 내역이에요.`} className="!py-6" />
            <div className="flex flex-col gap-[16px] w-full">
              {refundItems.map((item) => (
                <RefundHistoryCard key={item.id} item={item} />
              ))}
            </div>
            <OngoingRefundButton />
          </section>
        ) : (
          <EmptyRefundHistory />
        )}
      </div>
    </main>
  );
}

MyRefundHistoryPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <RefundItemFetchGuard>
      <PageViewEventLogger pageName={'history'}>{page}</PageViewEventLogger>
    </RefundItemFetchGuard>
  );
};
